'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Avatar = function (_a) {
    var src = _a.src, height = _a.height, maxHeight = _a.maxHeight, width = _a.width, maxWidth = _a.maxWidth, left = _a.left, right = _a.right, alt = _a.alt, className = _a.className, onClick = _a.onClick, loading = _a.loading, size = _a.size, isCircle = _a.isCircle;
    return (React__default['default'].createElement("img", { src: src, className: className ? className + " avatar" : 'avatar', alt: alt || 'avatar', loading: loading || 'lazy', style: tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign({ display: 'inline-flex' }, (maxHeight ? { maxHeight: maxHeight } : { height: height || size || '30px' })), (maxWidth ? { maxWidth: maxWidth } : { width: width || size || '30px' })), (left && { left: left })), (right && { right: right })), (isCircle && { borderRadius: '50%' })), onClick: onClick }));
};

exports.Avatar = Avatar;
//# sourceMappingURL=Avatar.js.map
